import React, { Component } from "react";
import "react-phone-number-input/style.css";
import veiuligheidshuis from "../../assets/Curacao Ministerie.PNG";
import PhoneInput from "react-phone-number-input";
import Api from "../../Api";

class ZVHCForm extends Component {
  constructor(props) {
    super(props);

    this.state = {
      defDossier: null,
      veiligheidshuis: [],
      verantwoordelijk: "",
      instelling: "",
      Functie_melder: "",
      achternaam_melder: "",
      email: "",
      phone: "",
      date: "",
      voornamen: "",
      achternaam: "",
      voorletters: "",
      geboorteplaats: "",
      geboortedatum: "",
      identiteitsnummer: "",
      geslacht: [],
      geslacht_2: [],
      adres_conform: "",
      telefoonnummer_2: "",
      rol_betrokkene: [],
      betrokkene: "",
      problematiek: "",
      huisvesting: [],
      huisvesting_toelichting: "",
      gezondheid: "",
      werk: "",
      financien: "",
      sociale_omgeving: "",
      overing: "",
      verhelpen: "",
      waarom_schaalt: "",
      vraag_aan: "",
      betrokken: "",
      geprobeerd: "",
      welke_partners: "",
      showModal: false,
      loading: false,
    };

    this.handleCheck = this.handleCheck.bind(this);
    this.TextField = this.TextField.bind(this);
    this.TextAreaField = this.TextAreaField.bind(this);
    this.EmailField = this.EmailField.bind(this);
    this.SelectField = this.SelectField.bind(this);
    this.DateField = this.DateField.bind(this);
    this.CheckBoxField = this.CheckBoxField.bind(this);
    this.PhoneField = this.PhoneField.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  TextField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            {...register(name, rules)}
            type="text"
            className="block w-full border border-gray-300 text-gray-900 text-sm md:w-[30vw] rounded focus:ring-blue-500 focus:border-blue-500  p-1 "
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  EmailField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <input
            {...register(name, rules)}
            type="email"
            className="block w-full border border-gray-300 text-gray-900 text-sm md:w-[30vw] rounded focus:ring-blue-500 focus:border-blue-500  p-1 "
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  SelectField(label, name, options, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <select
            {...register(name, rules)}
            name={name}
            onChange={(e) => {
              this.setState({ [name]: [e.target.value] });
            }}
            className="block w-full border border-gray-300 text-gray-900 text-sm md:w-[30vw] rounded focus:ring-blue-500 focus:border-blue-500  p-1 "
          >
            <option value="">Selecteer een optie</option>
            {options.map((opt) => (
              <option value={opt.value}>{opt.label}</option>
            ))}
          </select>
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  DateField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>

          <input
            {...register(name, rules)}
            type="date"
            className="block w-full border border-gray-300 text-gray-900 text-sm md:w-[30vw] rounded focus:ring-blue-500 focus:border-blue-500  p-1 "
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
          />
          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  CheckBoxField(label, name, options, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;
    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules?.required && <span className="text-red-500">*</span>} {label}
          </label>
          {options.map((opt, idx) => (
            <div className="flex gap-2" key={idx}>
              <input
                type="checkbox"
                {...register(name, rules)}
                value={opt.value}
              />
              <label className="float-left text-left">{opt.label}</label>
            </div>
          ))}

          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  PhoneField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules?.required && <span className="text-red-500">*</span>} {label}
          </label>
          <PhoneInput
            placeholder="Enter phone number"
            {...register(name, rules)}
            value={this.state[name]}
            onChange={(value) => this.setState({ [name]: value })}
            className="block w-full border border-gray-300 text-gray-900 text-sm md:w-[30vw] rounded focus:ring-blue-500 focus:border-blue-500  p-1 "
          />

          {errors[name]?.type === "required" && (
            <span className="text-red-500 text-sm">{errors[name].message}</span>
          )}
        </div>
      </>
    );
  }

  handleCheck(att, chek, id) {
    let attribute = this.state[att];
    if (chek) {
      attribute = [...attribute, id];
    } else {
      attribute = attribute.filter((e) => e !== id);
    }
    this.setState({ [att]: attribute });
  }

  TextAreaField(label, name, rules) {
    const {
      register,
      formState: { errors },
    } = this.props;

    return (
      <>
        <div className="flex flex-col items-start w-full">
          <label
            for="tussenvoegsels"
            className="form-label fw-bold float-start"
          >
            {rules.required && <span className="text-red-500">*</span>} {label}
          </label>
          <textarea
            rows={7}
            {...register(name, rules)}
            onChange={(e) => {
              this.setState({ [name]: e.target.value });
            }}
            className="block p-2 w-full text-sm text-gray-900  rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 "
          ></textarea>

          {errors[name] && (
            <span className="text-red-500 text-sm">This field is required</span>
          )}
        </div>
      </>
    );
  }

  async onSubmit(data) {
    this.setState({ loading: true });

    const personenData = {
      defDossier: 1818,
      31453: data.geboortedatum,
      31227: data.email,
      31260: data.identiteitsnummer,
      31256: data.geslacht_2,
      31205: data.telefoonnummer_2,
      31212: data.voorletters,
      31201: data.voornamen,
      31217: data.achternaam,
      32978: data.geboorteplaats,
    };

    const personen = await Api.dossiers.Create(personenData);
    const aanmeldingenData = {
      defDossier: 1831,
      60807: data.veiligheidshuis,
      32985: [data.verantwoordelijk],
      60809: data.instelling,
      60810: data.Functie_melder,
      60811: data.achternaam_melder,
      60812: data.email,
      60813: data.phone,
      31377: data.date,
      60815: data.voornamen + data.achternaam,
      60816: data.voorletters,
      60817: data.geboortedatum,
      61237: data.identiteitsnummer,
      60818: data.geslacht,
      60819: data.adres_conform,
      60820: data.telefoonnummer_2,
      60821: data.wijk,
      60822: data.rol_betrokkene,
      60823: data.betrokkene,
      60824: data.problematiek,
      68065: data.huisvesting,
      68066: data.huisvesting_toelichting,
      60831: data.verhelpen,
      84468: data.waarom_schaalt,
      60833: data.vraag_aan,
      60834: data.betrokken,
      60835: data.geprobeerd,
      60836: data.welke_partners,
      31409: [personen.id],
    };
    await Api.dossiers.Create(aanmeldingenData);
    this.setState({ loading: false });
    this.setState({ showModal: true });
  }

  render() {
    const { handleSubmit } = this.props;

    return (
      <>
        {this.state.loading && (
          <div className="flex items-center justify-center h-screen fixed w-full z-50">
            <div className="bg-slate-500 absolute w-full h-full  opacity-50"></div>
            <div class="relative">
              <div className="h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-200"></div>
              <div className="absolute top-0 left-0 h-24 w-24 rounded-full border-t-8 border-b-8 border-slate-300 animate-spin"></div>
            </div>
          </div>
        )}
        {this.state.showModal && (
          <div
            id="successModal"
            tabindex="-1"
            aria-hidden="true"
            class="flex  overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 z-50 justify-center items-center w-full md:inset-0 h-modal md:h-full"
          >
            <div className="bg-slate-500 absolute w-full h-full opacity-50"></div>
            <div class="relative p-4 w-full max-w-md h-full md:h-auto">
              <div class="relative p-4 text-center bg-white rounded-lg shadow dark:bg-gray-800 sm:p-5">
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                    this.props.reset();
                  }}
                  type="button"
                  class="text-gray-400 absolute top-2.5 right-2.5 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center dark:hover:bg-gray-600 dark:hover:text-white"
                  data-modal-toggle="successModal"
                >
                  <svg
                    aria-hidden="true"
                    class="w-5 h-5"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Close modal</span>
                </button>
                <div class="w-12 h-12 rounded-full bg-green-100 dark:bg-green-900 p-2 flex items-center justify-center mx-auto mb-3.5">
                  <svg
                    aria-hidden="true"
                    class="w-8 h-8 text-green-500 dark:text-green-400"
                    fill="currentColor"
                    viewBox="0 0 20 20"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clip-rule="evenodd"
                    ></path>
                  </svg>
                  <span class="sr-only">Success</span>
                </div>
                <p class="mb-4 text-lg font-semibold text-gray-900 dark:text-white">
                  Successfully!
                </p>
                <button
                  onClick={() => {
                    this.setState({ showModal: false });
                    this.props.reset();
                  }}
                  type="button"
                  class="py-2 px-3 text-sm font-medium text-center text-white rounded-lg bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:outline-none focus:ring-blue-300 "
                >
                  Continue
                </button>
              </div>
            </div>
          </div>
        )}

        <div className="p-5 d-flex flex-column gap-5">
          <div className="d-flex justify-content-center w-full">
            <img src={veiuligheidshuis} alt="logo Zorg-curacao" />
          </div>
          <h1 className="text-3xl font-bold pt-2">Aanmeldformulier</h1>
          <div className=" lg:[50%] shadow p-4 rounded bg-slate-50">
            <form
              onSubmit={handleSubmit(this.onSubmit)}
              className="flex flex-col gap-4 w-full items-start"
            >
              <div className="flex flex-col items-start justify-center gap-2">
                {this.CheckBoxField(
                  `U kunt iemand aanmelden bij het Veiligheidshuis indien alle  vragen met "JA" worden beantwoord:`,
                  "veiligheidshuis",
                  [
                    {
                      value: "33165",
                      label: " Zijn er problemen op meerdere leefgebieden?",
                    },
                    {
                      value: "33164",
                      label:
                        "Is er een hoog risico op crimineel en/of overlastgevend gedrag met risico's voor de veiligheid van de samenleving?",
                    },
                    {
                      value: "33163",
                      label:
                        "Is er samenwerking tussen meerdere ketenpartners nodig (bestuur/zorg/straf)?",
                    },
                  ],
                  {
                    required: {
                      value: true,
                      message: "field is required",
                    },
                  }
                )}
              </div>
              <div className="flex gap-5 flex-wrap">
                <div className="flex flex-col gap-2">
                  {this.SelectField(
                    "Selecteer de specifieke tafel waar het over gaat:",
                    "verantwoordelijk",
                    [
                      {
                        value: 525885,
                        label: "Risico Jeugdoverleg (RJO)",
                      },
                      {
                        value: 525886,
                        label: "Justitieel Casusoverleg (JCO)",
                      },
                      {
                        value: 525887,
                        label: "Criminele Families (CF)",
                      },
                      {
                        value: 525888,
                        label: "Relationeel Geweld (RG)",
                      },
                    ],
                    {
                      required: true,
                    }
                  )}
                  {this.TextField(
                    "Naam organisatie of instelling",
                    "instelling",
                    { required: true }
                  )}
                  {this.TextField("Functie melder", "Functie_melder", {
                    required: true,
                  })}
                  {this.TextField(
                    "Voor- en achternaam melder",
                    "achternaam_melder",
                    {
                      required: true,
                    }
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  {this.SelectField(
                    "Geslacht",
                    "geslacht",
                    [
                      {
                        value: 33170,
                        label: "Man",
                      },
                      {
                        value: 33171,
                        label: "Vrouw",
                      },
                      {
                        value: 33172,
                        label: "Anders",
                      },
                    ],
                    {
                      required: true,
                    }
                  )}
                  {this.EmailField("E-mailadres", "email", {
                    required: { value: true, message: "Email is required" },
                  })}
                  {this.PhoneField("Telefoonnummer", "phone", {
                    required: "This Field Is Required",
                  })}

                  {this.DateField("Datum aanmelding", "date", {
                    required: {
                      value: true,
                      message: "Datum aanmelding is required",
                    },
                  })}
                </div>
              </div>
              <hr />
              <h1 className="text-3xl font-bold pt-5">Betrokkene</h1>
              <div className="flex gap-5 flex-wrap">
                <div className="flex flex-col gap-2">
                  {this.TextField("Voornamen betrokkene", "voornamen", {
                    required: true,
                  })}
                  {this.TextField("Achternaam betrokkene", "achternaam", {
                    required: true,
                  })}
                  {this.TextField(" Voorletters", "voorletters", {
                    required: false,
                  })}
                  {this.DateField("Geboortedatum", "geboortedatum", {
                    required: "This Field required",
                  })}
                  {this.TextField("Geboorteplaats", "geboorteplaats", {
                    required: true,
                  })}
                  {this.TextField(
                    "Identiteitsnummer (ID)",
                    "identiteitsnummer",

                    {
                      required: false,
                    }
                  )}
                  {this.SelectField(
                    "Geslacht",
                    "geslacht_2",
                    [
                      {
                        value: 15938,
                        label: "Man",
                      },
                      {
                        value: 15941,
                        label: "Vrouw",
                      },
                      {
                        value: 15943,
                        label: "Onbekend",
                      },
                    ],
                    {
                      required: true,
                    }
                  )}
                </div>
                <div className="flex flex-col gap-2">
                  {this.TextField(
                    "Adres conform BRP (indien bekend)",
                    "adres_conform",
                    {
                      required: true,
                    }
                  )}
                  {this.PhoneField("Telefoonnummer", "telefoonnummer_2", {
                    required: "This Field Is Required",
                  })}
                  {this.TextField("Wijk", "wijk", {
                    required: false,
                  })}
                  {this.SelectField(
                    "Rol betrokkene (getuige/pleger/slachtoffer/betrokkenen)",
                    "rol_betrokkene",
                    [
                      {
                        value: 33173,
                        label: "Getuige",
                      },
                      {
                        value: 33174,
                        label: "Pleger",
                      },
                      {
                        value: 33175,
                        label: "Slachtoffer",
                      },
                      {
                        value: 33176,
                        label: "Betrokkenen",
                      },
                    ],
                    {
                      required: true,
                    }
                  )}
                  {this.TextAreaField(
                    "Is betrokkene al geïnformeerd over de aanmelding? Zo niet, wat is de reden?",
                    "betrokkene",
                    { required: "This Field Is Reuired" }
                  )}
                </div>
              </div>

              <hr />
              <h1 className="text-3xl font-bold pt-2">
                De situatiecheck en problematiek
              </h1>
              <div className="flex flex-col gap-2 items-start">
                {this.TextAreaField(
                  "En schets van de problematiek",
                  "problematiek",
                  { required: "This Field is Required" }
                )}

                <p className="text-left">
                  Graag beknopt en alleen relevante info delen (o.a. welke
                  manier de betrokkene crimineel en risicogevend gedrag vertoont
                  en/ of de veiligheid van betrokkene zelf, de omgeving of de
                  maatschappij in het geding is)
                </p>
              </div>
              <hr />
              <h1 className="text-3xl font-bold pt-2">
                Toelichting per leefgebied
              </h1>
              <label className="form-label fw-bold float-start">
                (alleen de bekende en relevante leefgebieden dienen te worden
                ingevuld)
              </label>
              <div className="flex flex-col justify-start w-full">
                {this.CheckBoxField(
                  `Habitatlijst:`,
                  "huisvesting",
                  [
                    {
                      value: 34670,
                      label: "Overig",
                    },
                    {
                      value: 34668,
                      label: "Sociale omgeving / Systeem",
                    },
                    {
                      value: 34667,
                      label: "Financien / Inkomen",
                    },
                    {
                      value: 34666,
                      label: "Werk",
                    },
                    {
                      value: 34665,
                      label: "Gezondheid",
                    },
                    {
                      value: 34664,
                      label: "Huisvesting",
                    },
                  ],
                  {
                    required: {
                      value: true,
                      message: "field is required",
                    },
                  }
                )}

                <br />
                {this.TextAreaField(
                  "Habitatlijst toelichting:",
                  "huisvesting_toelichting",
                  { required: "This Field is Required" }
                )}
              </div>

              <hr />
              <h1 className="text-3xl font-bold pt-2">Interventie</h1>
              {this.TextAreaField(
                "Wat is er geprobeerd om deze situatie te verhelpen?",
                "verhelpen",
                { required: "This Field is Required" }
              )}

              <hr />
              <h1 className="text-3xl font-bold pt-2">
                De aanpak Veiligheidshuis Curacao
              </h1>
              {this.SelectField(
                "Waarom schaalt u op naar het Veiligheidshuis?",
                "waarom_schaalt",
                [
                  {
                    value: 43088,
                    label: "Verbinding tussen zorg en straf",
                  },
                  {
                    value: 43087,
                    label: "Overstijgende problematiek",
                  },
                  {
                    value: 43086,
                    label: "Stagnatie in de samenwerking",
                  },
                  {
                    value: 43085,
                    label: "Organiseren van rondetafel",
                  },
                ],
                {
                  required: true,
                }
              )}
              {this.TextAreaField(
                "Wat is uw vraag aan / verwachting van het Veiligheidshuis?",
                "vraag_aan",
                { required: "This Field is Required" }
              )}
              {this.TextAreaField(
                "Welke partners zijin er op dit moment al betrokken?",
                "betrokken",
                { required: "This Field is Required" }
              )}
              {this.TextAreaField(
                "Wat is er geprobeerd om deze situatie te verhelpen?",
                "geprobeerd",
                { required: "This Field is Required" }
              )}
              {this.TextAreaField(
                "Welke partners uit de verschillende ketens  (bestuur/zorg/strafrecht? zijn nodig?)",
                "welke_partners",
                { required: "This Field is Required" }
              )}

              <div className="col-span-4">
                <button
                  type="submit"
                  className="bg-gray-300 hover:bg-gray-400 text-gray-800 font-bold py-2 px-4 rounded inline-flex items-center"
                >
                  Verstuur
                </button>
              </div>
            </form>
          </div>
        </div>
      </>
    );
  }
}

export default ZVHCForm;
